import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePrivilege } from '../../components/priviledge/PriviledgeProvider';
import { menuRoutes } from '../../router/menu';

const CallsLanding = () => {
    const navigate = useNavigate();
    const { userCan } = usePrivilege();
    const canViewAssignments = userCan('show_all_system_facilitators', 'user');
    const canViewTotalCalls = userCan('list_calls', 'calls');

    useEffect(() => {
        if (canViewAssignments) {
            navigate(menuRoutes.calls.path + menuRoutes.calls.assignments, { replace: true });
            return;
        }

        if (canViewTotalCalls) {
            navigate(menuRoutes.calls.path + menuRoutes.calls.total, { replace: true });
            return;
        }

        navigate(menuRoutes.calls.path + menuRoutes.calls.list, { replace: true });
    }, [canViewAssignments, canViewTotalCalls, navigate]);

    return null;
};

export default CallsLanding;
